import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type UpdateShareColorSchemeMutationVariables = Types.Exact<{
  shareId: Types.Scalars['ID']['input'];
  colorPickerMode?: Types.InputMaybe<Types.ColorPickerModeInput>;
  accentColor?: Types.InputMaybe<Types.Scalars['HexColorCode']['input']>;
  backgroundColor?: Types.InputMaybe<Types.Scalars['HexColorCode']['input']>;
  textColor?: Types.InputMaybe<Types.Scalars['HexColorCode']['input']>;
}>;


export type UpdateShareColorSchemeMutation = { __typename?: 'Mutation', updateShare?: { __typename?: 'UpdateSharePayload', share?: { __typename?: 'AdHocAssetsShare', id: string, colorPickerMode: Types.ColorPickerMode, accentColor?: string | null, backgroundColor?: string | null, textColor?: string | null } | { __typename?: 'CollectionShare', id: string, colorPickerMode: Types.ColorPickerMode, accentColor?: string | null, backgroundColor?: string | null, textColor?: string | null } | null } | null };


export const UpdateShareColorScheme = /*#__PURE__*/ gql`
    mutation UpdateShareColorScheme($shareId: ID!, $colorPickerMode: ColorPickerModeInput, $accentColor: HexColorCode, $backgroundColor: HexColorCode, $textColor: HexColorCode) {
  updateShare(
    input: {shareId: $shareId, settings: {colorPickerMode: $colorPickerMode, accentColor: $accentColor, backgroundColor: $backgroundColor, textColor: $textColor}}
  ) {
    share {
      id
      colorPickerMode
      accentColor
      backgroundColor
      textColor
    }
  }
}
    ` as unknown as DocumentNode<UpdateShareColorSchemeMutation, UpdateShareColorSchemeMutationVariables>;

          

          export const useUpdateShareColorSchemeMutation = (options?:MutationHookOptions<UpdateShareColorSchemeMutation, UpdateShareColorSchemeMutationVariables>) => useMutation(UpdateShareColorScheme, options);
          

          export type UpdateShareColorSchemeMutationOptions = MutationHookOptions<UpdateShareColorSchemeMutation, UpdateShareColorSchemeMutationVariables>;

          

          export type UpdateShareColorSchemeMutationResult = ReturnType<typeof useUpdateShareColorSchemeMutation>[1];

          
